<template>
  <div>
    <GmapMap
      :draggable="false"
      :center="center"
      :zoom="$vuetify.breakpoint.mdAndUp ? 15 : 13.5"
      style="width: 100vw; height: 100vh"
    >
      <GmapMarker
        :animation="1"
        class="g-marker"
        :key="index"
        v-for="(m, index) in markers"
        :position="m"
        @click="center = m; $emit('loadedMarkers')"
        :icon="markerOptions"
      />
    </GmapMap>
  </div>
</template>

<script>
const mapMarker = require("../../assets/svg/map-marker.png");

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
    showMarkers: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      google: null,
      map: null,
      showMarker: false,
      center: { lat: 6.665, lng: 3.406 },
      markers: [{ lat: 6.665, lng: 3.406 }],
      markerOptions: {
        url: `${mapMarker}`,
        size: { width: 90, height: 90, f: "px", b: "px" },
        scaledSize: { width: 70, height: 70, f: "px", b: "px" },
      },
    };
  },

  async mounted() {
    // const googleMapApi = await new Loader({
    //   apiKey: "AIzaSyCBiexESbG6d0k_lb2kofazU_51r6-I8IQ",
    // });

    // console.log(googleMapApi);
    // this.google = googleMapApi;
    // this.initializeMap();
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    },
    initMarkers() {
      this.markers = [{ lat: 6.665, lng: 3.406 }];

      let newMarkers = [
        { lat: 6.675, lng: 3.416 },
        { lat: 6.667, lng: 3.417 },
        { lat: 6.6678, lng: 3.427 },
        { lat: 6.6678, lng: 3.387 },
        { lat: 6.6578, lng: 3.385 },
      ];

      newMarkers.forEach((element, idx) => {
        setTimeout(() => {
          this.markers.push(element);
        }, 500 * idx);
      });
    },
  },
  watch: {
    showMarkers(v) {
      if (v) {
        this.initMarkers();

        setTimeout(() => {
          this.$emit("loadedMarkers");
        }, 2700);
      }
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 100%;
}
</style>
